import React from 'react'

require('./index.scss')

const Note = (props) => {
  return (
    <div className={`app-Note${props.warning ? "-warning" : ""}`}>
      {props.children}
    </div>
  )
}

export default Note;
